import { render, staticRenderFns } from "./ChangeHistory.vue?vue&type=template&id=17b2c8d0&scoped=true&"
import script from "./ChangeHistory.vue?vue&type=script&lang=js&"
export * from "./ChangeHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChangeHistory.vue?vue&type=style&index=0&id=17b2c8d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2c8d0",
  null
  
)

export default component.exports